import { FetchUserGuidesParams } from './types';
import { gatewayApiAgent } from '../../common/api/apiAgents';
import { UserGuides } from '../../common/api-types/director';

export const fetchUserGuides = async (params: FetchUserGuidesParams): Promise<UserGuides> => {
  const res = await gatewayApiAgent.get(`/director/public/v1/user-guides`, { params });
  return res.data;
};
